export default class TimeCalculator {
  calculate(distance: number, cruiseRate: number): number {
    let hours = distance / cruiseRate

    hours = Math.ceil(hours * 12) / 12

    return parseFloat(Math.ceil(hours * 10).toFixed(1)) / 10
  }
}
